import React from 'react';
import DataTable from "../../components/data-table/DataTable";
import {getJuridicalPersons, navLinks} from "../../services/organization";
import LeftBar from "../../components/left-bar/LeftBar";
import NavigationLinks from "../../components/navigation-links/NavigationLinks";
import Content from "../../components/content/Content";
import SearchField from "../../components/fields/SearchField";
import ActionButton from "../../components/button/ActionButton";

const columnData = [
    { id: 'shortName', numeric: false, disablePadding: false, label: 'Короткое название' },
    { id: 'fullName', numeric: false, disablePadding: false, label: 'Полное название' },
    { id: 'email', numeric: false, disablePadding: false, label: 'Почта' },
    { id: 'phone', numeric: false, disablePadding: false, label: 'Телефон' },
    { id: 'ogrn', numeric: false, disablePadding: false, label: 'ОГРН' },
    { id: 'inn', numeric: false, disablePadding: false, label: 'ИНН' },
];

class JuridicalPersonListPage extends React.Component {

    state = {
        search: {
            search: null
        },
        refreshTable: false
    };

    handleChange = prop => event => {
        this.setState({
            search: {
                ...this.state.search,
                [prop]: event.target.value,
            }
        });
    };

    handleClickSearch = () => {
        this.setState(state => ({ refreshTable: !state.refreshTable }));
    };

    handleAdd = () => {
        this.props.history.push(`/organization/juridical-persons/view/0`);
    };

    getTableData = (...params) => {
        const {search} = this.state;
        return getJuridicalPersons(search, ...params);
    };

    render() {
        const { search,refreshTable } = this.state;

        return (
            <React.Fragment>
                <LeftBar navigationLinks={<NavigationLinks links={navLinks}/>}>
                    <SearchField
                        value={search.search}
                        onChange={this.handleChange('search')}
                        onClick={this.handleClickSearch}
                        label="Поиск"
                    />
                    <br />
                    <br />
                    <ActionButton onClick={this.handleAdd}>Добавить</ActionButton>
                </LeftBar>
                <Content title="Юридические лица">
                    <DataTable
                        columnData={columnData}
                        dataFunc={this.getTableData}
                        linkTemplate={(item) => `/organization/juridical-persons/view/${item.id}`}
                        selector={false}
                        refresh={refreshTable}
                    />
                </Content>
            </React.Fragment>
        );
    }
}

export default JuridicalPersonListPage;
